import { CSSProperties, MouseEvent, PropsWithChildren } from 'react';
import { Link as LinkDOM } from 'react-router-dom';

import { useLink } from './useLink';

export function Link(
	props: PropsWithChildren<{
		to?: string;
		target?: string;
		rel?: string;
		style?: CSSProperties;
		onClick?: (event: MouseEvent) => void;
		navigationState?: object;
	}>,
) {
	const { to, navigationState, ...rest } = props;
	const path = useLink(props.to);

	if (!path || !to) {
		return <div {...rest}>{props.children}</div>;
	}

	if (to.startsWith('https://')) {
		return (
			<a {...rest} href={to}>
				{props.children}
			</a>
		);
	}

	if (navigationState) {
		const [pathname, params] = path.split('?');

		return (
			<LinkDOM {...rest} to={{ pathname, search: params && `?${params}`, state: navigationState }}>
				{props.children}
			</LinkDOM>
		);
	} else {
		return (
			<LinkDOM {...rest} to={path}>
				{props.children}
			</LinkDOM>
		);
	}
}
